module.exports = __webpack_public_path__ + "build/assets/Aleo-Bold-65853ac3f982689d7b1057176ea754c7.woff";